/* Thermal Receipt 80mm - prints-ready */

export default function ThermalReceipt({ venda, unidade }) {
  if (!venda) return null;

  const dt = new Date(venda.data_venda);
  const dataStr = dt.toLocaleDateString("pt-BR");
  const horaStr = dt.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

  const money = (v) => `R$ ${Number(v).toFixed(2).replace(".", ",")}`;
  const pad = (s, n) => String(s).padEnd(n, " ");
  const padR = (s, n) => String(s).padStart(n, " ");

  return (
    <div id="thermal-receipt" className="thermal-receipt mx-auto border border-neutral-300">
      <div className="text-center">
        <div className="font-bold text-sm uppercase">{unidade?.nome || "Troca de Óleo"}</div>
        <div className="text-[10px]">CUPOM DE VENDA · NÃO FISCAL</div>
      </div>
      <hr />
      <div className="text-[11px]">
        <div>DATA: {dataStr} {horaStr}</div>
        <div>VENDA: #{venda.id.slice(0, 8).toUpperCase()}</div>
        <div>VENDEDOR: {venda.vendedor_nome}</div>
        {venda.cliente_nome && <div>CLIENTE: {venda.cliente_nome}</div>}
        {venda.placa && <div>PLACA: {venda.placa}</div>}
        {venda.km_atual != null && <div>KM: {venda.km_atual}</div>}
      </div>
      <hr />
      <div className="text-[11px]">
        <div className="font-bold">ITENS</div>
        {venda.itens.map((it, idx) => (
          <div key={idx} className="mt-1">
            <div>{it.nome}</div>
            <div>
              {pad(`${it.quantidade} x ${money(it.preco_unitario)}`, 22)}
              {padR(money(it.subtotal), 10)}
            </div>
          </div>
        ))}
      </div>
      <hr />
      <div className="text-[11px]">
        <div className="flex justify-between">
          <span>SUBTOTAL</span>
          <span>{money(venda.total_bruto)}</span>
        </div>
        <div className="flex justify-between">
          <span>DESCONTO ({Number(venda.percentual_desconto).toFixed(1)}%)</span>
          <span>- {money(venda.total_desconto)}</span>
        </div>
        <div className="flex justify-between font-bold text-sm mt-1">
          <span>TOTAL</span>
          <span>{money(venda.total_liquido)}</span>
        </div>
      </div>
      <hr />
      <div className="text-center text-[10px] mt-2">
        OBRIGADO PELA PREFERÊNCIA!
        <br />
        Próxima troca em até 6 meses.
      </div>
    </div>
  );
}
